import { trpc as ResourceManagerTrpc } from '@tencent/tpro_buglyqq_resource_manager_resource';

export const { ProductExceedStatus } = ResourceManagerTrpc.buglyqq.resource_manager;
export type ProductExceedStatus = ResourceManagerTrpc.buglyqq.resource_manager.ProductExceedStatus;
export type IGetProductExceedRsp = ResourceManagerTrpc.buglyqq.resource_manager.IGetProductExceedRsp;
export type IOverdueDataRecoveryBannerRsp = ResourceManagerTrpc.buglyqq.resource_manager.IOverdueDataRecoveryBannerRsp;
export type ResourceStatus = ResourceManagerTrpc.buglyqq.resource_manager.ResourceStatus;
export const { ResourceStatus } = ResourceManagerTrpc.buglyqq.resource_manager;
export const { Dimension } = ResourceManagerTrpc.buglyqq.resource_manager;
export type BindingStatus = ResourceManagerTrpc.buglyqq.resource_manager.BindingStatus;
export const { BindingStatus } = ResourceManagerTrpc.buglyqq.resource_manager;
export const { RemindMuteAction } = ResourceManagerTrpc.buglyqq.resource_manager;
export type RemindMuteAction = ResourceManagerTrpc.buglyqq.resource_manager.RemindMuteAction;
